import { render, staticRenderFns } from "./AssignTagOnContactSDData.vue?vue&type=template&id=24ef17f2&scoped=true"
import script from "./AssignTagOnContactSDData.vue?vue&type=script&lang=js"
export * from "./AssignTagOnContactSDData.vue?vue&type=script&lang=js"
import style0 from "./AssignTagOnContactSDData.vue?vue&type=style&index=0&id=24ef17f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ef17f2",
  null
  
)

export default component.exports